import { render, staticRenderFns } from "./ChamBoard.vue?vue&type=template&id=7973d010&"
import script from "./ChamBoard.vue?vue&type=script&lang=js&"
export * from "./ChamBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports